<template>
	<nk-box
		v-if="typeof context !== 'undefined' && context.length > 0"
		varaint="sidebar"
	>
		<div>
			<nk-title size="lg">Aktuelles</nk-title>
			<hr />

			<nk-row vertical-gutter="2">
				<nk-col v-for="(artikel, index) in context" :key="index" cols="full">
					<nk-meta v-if="artikel.news">
						<nk-icon icon="news" class="mr-1" />
						{{ getDateTimeString(artikel.datum_von) }}
					</nk-meta>
					<nk-link v-if="artikel.detailURL" :link="artikel.detailURL">
						<nk-title size="md">
							{{ artikel.titel }}
						</nk-title>
					</nk-link>
					<nk-title v-else size="md">
						{{ artikel.titel }}
					</nk-title>
				</nk-col>
			</nk-row>
		</div>
	</nk-box>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {object} context
 */
export default {
	name: 'NkSidebarBrancheneintragAktuelles',

	mixins: [TemplatesDefault],

	methods: {
		getDateTimeString(object) {
			return this.$formatTime(object);
		},
		getDetailURL(rubriken) {
			if (rubriken.length && rubriken[0].detailURL) {
				return rubriken[0].detailURL;
			}

			return '';
		},
	},
};
</script>
